import { render, staticRenderFns } from "./CloseCircle.vue?vue&type=template&id=24ffa2ad&"
import script from "./CloseCircle.vue?vue&type=script&lang=ts&"
export * from "./CloseCircle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports